import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReduxHooks from '../../store/ReduxHooks';
import { actionCreators } from '../../store/actions';
import ProfileManager from '../../services/api/ProfileManager';
import { RouteEnum } from '../../routes/routes';
import { useFooter } from '../../providers/FooterProvider';
import { Button, Select, Switch } from 'antd';
import Layout from '../../components/layout/Layout';
import { toast } from 'react-toastify';

export default function Index() {
  const { t } = useTranslation(null, { keyPrefix: 'Views:BusyMode' });

  const navigate = useNavigate();
  const { setFooterContent } = useFooter();

  const company = useSelector((state) => state.company?.company);
  const { busy_mode_minutes } = company;
  const [hasBusyMode, setHasBusyMode] = useState(busy_mode_minutes > 0);
  const [busyModeMinutes, setBusyModeMinutes] = useState(busy_mode_minutes ?? 15);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setFooterContent(
      <div className="p-2 left-0 flex w-full justify-between bg-white border-t border-gray-200">
        <Button type="primary" size="large" onClick={submit} loading={loading} className="w-full">
          {t('buttons.save')}
        </Button>
      </div>,
    );

    return () => setFooterContent(null);
  }, [hasBusyMode, busyModeMinutes, loading]);

  const submit = async () => {
    setLoading(true);
    const { success, data } = await ProfileManager.update({
      ...company,
      busy_mode_minutes: hasBusyMode ? busyModeMinutes : null,
    });
    setLoading(false);

    if (!success) {
      return toast.error(t('toasts.failed_to_save_changes'));
    }

    toast.success(t('toasts.changes_got_saved'));
    ReduxHooks.dispatch(actionCreators.company.set(data.data));

    return navigate(RouteEnum.Home);
  };

  return (
    <Layout.Page className="space-y-md">
      <div className="flex gap-md">
        <Switch
          id="has_busy_mode"
          checked={hasBusyMode}
          onChange={(checked) => setHasBusyMode(checked)}
          className="my-auto"
        />
        <label htmlFor="has_busy_mode" className="my-auto">
          {t('form.has_busy_mode.label')}
        </label>
      </div>
      {hasBusyMode && (
        <div className="flex gap-md">
          <Select
            value={busyModeMinutes}
            onChange={setBusyModeMinutes}
            options={[10, 15, 20, 25, 30, 45, 60].map((item) => ({
              value: item,
              label: t(`form.busy_mode_minutes.options.${item}`),
            }))}
            className="my-auto min-w-[100px]"
          />
          <label htmlFor="auto_print" className="my-auto">
            {t('form.busy_mode_minutes.label')}
          </label>
        </div>
      )}
    </Layout.Page>
  );
}
